
import React, { useRef, useState } from 'react';
import { AiOutlineCheck, AiOutlineCopy, AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';



const ContactUs = () => {
    const [copyStatus, setCopyStatus] = useState("");
    const [copiedContact, setCopiedContact] = useState("");
    const copyTimeout = useRef(null);
    const email = "johnersenyoute509@gmail.com";
    const phone = "+1 617-291-7253";

    const copyContact = async (contactType, value) => {
        const message = contactType === "email"
            ? "Email address copied."
            : "Phone number copied.";

        try {
            await navigator.clipboard.writeText(value);
            window.clearTimeout(copyTimeout.current);
            setCopiedContact(contactType);
            setCopyStatus(message);
            copyTimeout.current = window.setTimeout(() => {
                setCopiedContact("");
                setCopyStatus("");
            }, 2500);
        } catch (error) {
            window.prompt(`Copy this ${contactType}:`, value);
        }
    };

    return (
        <section className="bg-pattern px-3 py-8 sm:px-4 lg:py-12">
            <div className="mx-auto w-full max-w-4xl">
                <div className="rounded-2xl bg-white p-3 shadow-2xl sm:p-4 lg:rounded-3xl lg:p-6">
                    <div className="rounded-2xl bg-blue-change p-5 text-white sm:p-8 lg:p-10">
                        <p className="text-sm font-bold uppercase tracking-wide text-blue-second">Contact</p>
                        <h1 className='mt-2 text-3xl font-black leading-tight drop-shadow-2xl sm:text-4xl'>Keep in touch</h1>
                        <p className="mt-3 max-w-2xl text-sm leading-relaxed sm:mt-4 sm:text-base">
                            Have a role, project, or collaboration in mind? Reach out directly by email or phone.
                        </p>
                        <div className='mt-5 grid gap-3 sm:mt-6 sm:grid-cols-2'>
                            <button
                                aria-label="Copy email address"
                                className='flex min-w-0 cursor-pointer items-center gap-3 rounded-xl bg-white p-3 text-left text-blue-change shadow-lg focus:outline-none focus:ring-4 focus:ring-white focus:ring-opacity-60'
                                type="button"
                                onClick={() => copyContact("email", email)}
                            >
                                <AiOutlineMail className="shrink-0 text-2xl" />
                                <span className="min-w-0 flex-1 break-words text-sm font-bold leading-snug sm:text-base">{email}</span>
                                {copiedContact === "email" ? (
                                    <AiOutlineCheck className="shrink-0 text-xl" />
                                ) : (
                                    <AiOutlineCopy className="shrink-0 text-xl" />
                                )}
                            </button>
                            <button
                                aria-label="Copy phone number"
                                className='flex min-w-0 cursor-pointer items-center gap-3 rounded-xl bg-white p-3 text-left text-blue-change shadow-lg focus:outline-none focus:ring-4 focus:ring-white focus:ring-opacity-60'
                                type="button"
                                onClick={() => copyContact("phone", phone)}
                            >
                                <AiOutlinePhone className="shrink-0 text-2xl" />
                                <span className="min-w-0 flex-1 text-sm font-bold sm:text-base">{phone}</span>
                                {copiedContact === "phone" ? (
                                    <AiOutlineCheck className="shrink-0 text-xl" />
                                ) : (
                                    <AiOutlineCopy className="shrink-0 text-xl" />
                                )}
                            </button>
                        </div>
                        {copyStatus && (
                            <p className="mt-3 text-center text-sm font-bold text-white">{copyStatus}</p>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactUs;
